import { makeStyles } from '@mui/styles';

const colors = {
    'orange': '#ff9e00',
    'yellow': '#ffdf10',
    'green': '#00d456',
    'teal': '#00d7ff',
    'blue': '#0078ff',
};

const sizes = {
    small: {
        width: 5,
        height: 5,
    },

    medium: {
        width: 8,
        height: 8,
    },
    
    large: {
        width: 8,
        height: 8,
    }
}
export default makeStyles(theme => ({
 

    dot: ({color, size }) => {
         
        function getSize () {
            if (sizes[size]) {
                return sizes[size];
            }
            return sizes.small;
        }
    
        function getColor () {
            if (colors[color]) {
                return colors[color];
            }
            return colors.orange;
        }

        return {
            ...getSize(),
            fontSize: '10px',
            backgroundColor: getColor(),
            borderRadius: '50%',
            transition: theme.transitions.create('background-color'),
            cursor: 'pointer',
        };
    },

    dotMargin: {
        marginRight: '20px',
    },
    
}));
